import { Link } from "react-router-dom";
import { services } from "@/mocks/services";

const serviceImages = [
  "https://public.readdy.ai/ai/img_res/8b0157a1700dc35d18cafc326b2c1d9a.jpg",
  "https://readdy.ai/api/search-image?query=brand%20new%20high%20efficiency%20air%20conditioning%20unit%20being%20installed%20outside%20luxury%20home%20clean%20white%20equipment%20professional%20installation%20crew%20dallas%20texas%20bright%20day%20photorealistic&width=600&height=400&seq=svc-img-2&orientation=landscape",
  "https://readdy.ai/api/search-image?query=hvac%20technician%20performing%20preventative%20maintenance%20inspection%20on%20air%20conditioning%20system%20checking%20filters%20coils%20clean%20organized%20professional%20residential%20home%20photorealistic&width=600&height=400&seq=svc-img-3&orientation=landscape",
  "https://readdy.ai/api/search-image?query=emergency%20hvac%20service%20technician%20arriving%20at%20home%20at%20night%20urgent%20repair%20van%20parked%20outside%20residential%20property%20dramatic%20lighting%20professional%20photorealistic&width=600&height=400&seq=svc-img-4&orientation=landscape",
  "https://readdy.ai/api/search-image?query=professional%20air%20duct%20cleaning%20service%20technician%20with%20equipment%20inside%20clean%20modern%20home%20interior%20bright%20lighting%20residential%20hvac%20ductwork%20photorealistic&width=600&height=400&seq=svc-img-5&orientation=landscape",
  "https://readdy.ai/api/search-image?query=furnace%20heating%20system%20repair%20technician%20working%20on%20modern%20gas%20furnace%20inside%20clean%20utility%20room%20residential%20home%20professional%20tools%20photorealistic&width=600&height=400&seq=svc-img-6&orientation=landscape",
];

export default function ServicesOverview() {
  return (
    <section className="bg-[#030c15] py-28">
      <div className="max-w-7xl mx-auto px-6">

        {/* Section Header */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-end mb-16">
          <div>
            <p className="font-['Inter'] text-[#7DD3FC] text-xs font-semibold uppercase tracking-[0.18em] mb-4">
              Our Services
            </p>
            <h2 className="font-['Playfair_Display'] text-white text-4xl md:text-5xl font-bold leading-tight">
              Cooling Solutions Built for Performance &amp; Longevity
            </h2>
          </div>
          <div className="flex flex-col justify-end gap-5">
            <p className="font-['Inter'] text-white/85 text-base leading-[1.85]">
              Every service is engineered for the demands of Texas summers — fast, efficient, and built to outlast the heat.
            </p>
            <Link
              to="/services"
              className="inline-flex items-center gap-2 text-[#7DD3FC] font-['Inter'] text-sm font-semibold hover:gap-3 transition-all duration-300 whitespace-nowrap self-start"
            >
              View All Services <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {services.map((svc, idx) => (
            <Link
              key={svc.id}
              to={svc.href}
              className="group relative border rounded-2xl overflow-hidden cursor-pointer flex flex-col transition-all duration-300 hover:border-[#0EA5E9]/55 border-white/10 min-h-[320px]"
            >
              {/* Background image */}
              <div className="absolute inset-0 w-full h-full">
                <img
                  src={serviceImages[idx]}
                  alt={svc.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                {/* Dark overlay — heavier at bottom for text */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#020b14]/97 via-[#020b14]/75 to-[#020b14]/35" />
                {/* Extra left-edge depth */}
                <div className="absolute inset-0 bg-gradient-to-r from-[#020b14]/40 to-transparent" />
              </div>

              {/* Featured accent line */}
              {svc.featured && (
                <div className="absolute top-0 left-0 right-0 h-[2.5px] bg-gradient-to-r from-[#0EA5E9] via-[#38bdf8]/60 to-transparent z-10" />
              )}

              {/* Content */}
              <div className="relative z-10 flex flex-col flex-1 p-7">
                {/* Top row: icon + number */}
                <div className="flex items-start justify-between mb-auto">
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-white/10 border border-white/20 group-hover:bg-[#0EA5E9]/25 group-hover:border-[#0EA5E9]/50 transition-all duration-300 flex-shrink-0 backdrop-blur-sm">
                    <i className={`${svc.icon} text-white text-lg`}></i>
                  </div>
                  <span className="font-['Playfair_Display'] text-white/20 group-hover:text-white/35 text-3xl font-bold transition-colors duration-300 leading-none">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                </div>

                {/* Bottom text block */}
                <div className="mt-16 pt-5 border-t border-white/15">
                  <h3 className="font-['Inter'] text-white font-bold text-[1rem] mb-2.5 leading-snug drop-shadow-[0_1px_4px_rgba(0,0,0,0.8)]">
                    {svc.title}
                  </h3>
                  <p className="font-['Inter'] text-white text-sm leading-relaxed mb-5 opacity-90 drop-shadow-[0_1px_3px_rgba(0,0,0,0.9)]">
                    {svc.description}
                  </p>
                  <div className="flex items-center gap-1.5 text-[#7DD3FC] font-['Inter'] text-sm font-semibold group-hover:gap-2.5 transition-all duration-300 whitespace-nowrap">
                    Learn More <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Bottom trust note */}
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 mt-14 pt-10 border-t border-white/10">
          {[
            { icon: "ri-check-line", text: "All Major Brands Serviced" },
            { icon: "ri-check-line", text: "Residential & Commercial" },
            { icon: "ri-check-line", text: "Licensed & Insured" },
            { icon: "ri-check-line", text: "Same-Day Availability" },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-[#0EA5E9] text-xs`}></i>
              </div>
              <span className="font-['Inter'] text-white/85 text-sm whitespace-nowrap">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
